<div class="container">
  <div class="row no-gutters">
    <div class="col-12">
      <div class="d-flex popup-head align-items-center">
        <div class="popup-title mr-auto" translate>lblAddRentalCar</div>
        <div class="float-right">
          <a class="close mr-3" (click)="OnClose()" translate>
            <span class="" aria-hidden="true">&times;</span>
            </a>
        </div>
      </div>
      <form [formGroup]="addRentalCarForm" (ngSubmit)="AddRentalCar()">
        <div class="scrollbar">
          <div class="card-content">
            <div class="card-body p-0">
              <div class="form-row">
                <div class="col-6 af-form-group">
                  <label for="template-edit-dealerId" translate>lblSelectDealer<strong class="mlt6 required"> * </strong>
                  </label>
                  <div class='lbl-info'>
                    <ng-select  name="dealerId" placeholder="{{ 'lblSelectDealer' | translate }}"
                    (change)="setDealer($event)" 
                    [class.in-invalid]="cpf.dealerName.invalid && cpf.dealerName.touched" required
                      [ngClass]="{'is-invalid': cpf.dealerName.invalid && cpf.dealerName.touched}"
                      [disabled]="service.isEdit? true:false || isDisabled" formControlName="dealerName"
                   >
                    <ng-option *ngFor="let category of dealerList" [value]="category.value"
                      [disabled]="category.disabled">
                      {{category.text}}</ng-option>
                  </ng-select>
                    <div *ngIf="cpf.dealerName.invalid && (cpf.dealerName.dirty || cpf.dealerName.touched)"
                      class="help-block text-danger">
                      <div *ngIf="cpf.dealerName.errors.required">
                        <span translate>lblDealerRequired</span>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-6 af-form-group">
                  <label for="template-edit-company" translate>lblMake<strong class="mlt6 required"> * </strong>
                  </label>
                  <div class='lbl-info'>
                    <ng-select placeholder="{{ 'lblSelectMake' | translate }}" formControlName="company" name="company"
                      [class.in-invalid]="cpf.company.invalid && cpf.company.touched" required
                      [ngClass]="{'is-invalid': cpf.company.invalid && cpf.company.touched}" (change)="onMakeSelected($event)">
                      <ng-template ng-header-tmp>
                        <span class="mbold w-66px">Code</span>
                        <span class="mbold" translate>lblMake</span>
                      </ng-template>
                      <ng-option *ngFor="let brand of brandList" [value]="brand.brandCode">
                        <span class="w-66px">{{brand.brandCode}}</span>
                        <span class="mx-2 hide-ng-dropdown-panel">-</span>
                        <span>{{brand.brandName}}</span>
                      </ng-option>
                    </ng-select>
                    <div *ngIf="cpf.company.invalid && (cpf.company.dirty || cpf.company.touched)" class="help-block text-danger">
                      <div *ngIf="cpf.company.errors.required">
                        <span translate>lblRequiredMake</span>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-6 af-form-group">
                  <label for="template-edit-model" translate>lblModel<strong class="mlt6 required"> * </strong>
                  </label>
                  <div class='lbl-info'>
                    <ng-select placeholder="{{ 'lblSelectModel' | translate }}" name="model" formControlName="model"
                    [class.in-invalid]="cpf.model.invalid && cpf.model.touched" required  [(ngModel)]="RentalCarInfo.model"
                    [ngClass]="{'is-invalid': cpf.model.invalid && cpf.model.touched}">
                    <ng-option *ngFor="let models of modelList" [value]="models.description">
                      {{models.description}}
                    </ng-option>
                  </ng-select>
                  <div *ngIf="cpf.model.invalid && (cpf.model.dirty || cpf.model.touched)" class="help-block text-danger">
                    <div *ngIf="cpf.model.errors.required">
                      <span translate>lblRequiredModel</span>
                    </div>
                  </div>
                  </div>
                </div>

                <div class="col-6 af-form-group">
                  <label for="template-edit-fuel" translate>lblFuelType<strong class="mlt6" *ngIf="keepExtraFieldsMandatory"> * </strong> </label>
                  <div class='lbl-info'>
                    <ng-select placeholder="{{ 'lblFuel' | translate }}" name="fuel" formControlName="fuel" required
                      [class.in-invalid]="cpf.fuel.invalid && cpf.fuel.touched" [required]="keepExtraFieldsMandatory"
                      [ngClass]="{'is-invalid': cpf.fuel.invalid && cpf.fuel.touched}" [(ngModel)]="selectedAttributes">
                    
                      <ng-option *ngFor="let Fuel of fuels" [value]="Fuel.id">
                        {{Fuel.fuelType}}
                      </ng-option>
                    </ng-select>
                    <div *ngIf="cpf.fuel.invalid && (cpf.fuel.dirty || cpf.fuel.touched)" class="help-block text-danger">
                      <div *ngIf="cpf.fuel.errors.required"><span translate>lblFuelRequired</span>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-6 af-form-group">
                  <label for="template-edit-licensePlatNo" translate>lblRegNumber<strong class="mlt6 required"> * </strong>
                  </label>
                  <div class='lbl-info'>

                    <div class="input-group licplate">
                      <div class="input-group-prepend">
                        <div class="icn-flag" [ngClass]="licensePlateClass"></div>
                      </div>
                    
                      <input type="text" id="template-edit-licensePlatNo" name="licensePlatNo" 
                      class="form-control" formControlName="licensePlatNo" pattern="^[a-zA-Z0-9_ ]*$"
                      maxlength="20" required
                      [ngClass]="{'is-invalid': cpf.licensePlatNo.invalid && cpf.licensePlatNo.touched}" (keyup.enter)="searchVehicle()">
                          <button class="add-button btn btn-primary  px-2-5 radius-lb-flat" type="button"
                            (click)="searchVehicle()" translate><em class="fa fa-search"></em></button>    
                    </div>


                    
                    <div *ngIf="cpf.licensePlatNo.invalid && (cpf.licensePlatNo.dirty || cpf.licensePlatNo.touched)"
                      class="help-block text-danger">
                      <div *ngIf="cpf.licensePlatNo.errors.required"><span translate>lblLicensePlateRequired</span></div>
                      <div *ngIf="cpf.licensePlatNo.errors.pattern"><em class="fa fa-exclamation-circle"
                          aria-hidden="true"></em><span translate>lblSpecialCharacterAndSpacesAreNotAllowed
                        </span></div>
                    </div>
                  </div>
                </div>

                <div class="col-6 af-form-group">
                  <label translate>lblColor</label>
                  <div class='lbl-info'>
                    <input class="form-control" type="text" [value]="RentalCarInfo.color"
                    name="color"   autocomplete="off" formControlName="color">
                  </div>
                </div>

                <div class="col-6 af-form-group">
                  <label for="template-edit-year" translate>lblYear<strong class="mlt6 required" *ngIf="keepExtraFieldsMandatory"> * </strong> </label>
                  <div class='lbl-info'>
                    <input type="text" id="template-edit-year" name="year" class="form-control"
                    formControlName="year" pattern="^[0-9]*[0-9]" [required]="keepExtraFieldsMandatory" maxlength="4"
                      [ngClass]="{'is-invalid': cpf.year.invalid && cpf.year.touched}">
                    <div *ngIf="cpf.year.invalid && (cpf.year.dirty || cpf.year.touched)" class="help-block text-danger">
                      <div *ngIf="cpf.year.errors.required">
                        <span translate>lblYearRequired</span>
                      </div>
                      <div *ngIf="cpf.year.errors.pattern">
                        <span translate>lblProperValue
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-6 af-form-group">
                  <label for="template-edit-registrationDate" translate>lblRegistrationDate<strong class="mlt6 required" *ngIf="keepExtraFieldsMandatory">
                      * </strong>
                  </label>
                  <div class='lbl-info date'>
                    <input class="form-control datePicker width100force" appAfDatepicker [startDate]="'1949/12/31'"
                      [required]="keepExtraFieldsMandatory" [dateTime]="false" #StartDate="ngModel" [ngModelOptions]="{standalone: true}" [disableNextMonthDates]="true"
                      [ngClass]="{'is-invalid': StartDate.invalid && StartDate.touched}"
                      [(ngModel)]="RentalCarInfo.registrationDateTime" id="txtboxStartDate" name="StartDate"
                      type="text" value="">
                      <em class="far fa-calendar-alt fa-lg cursordisable"></em>
                    <div *ngIf="StartDate.invalid && (StartDate.dirty || StartDate.touched)"
                      class="help-block text-danger">
                      <div *ngIf="StartDate.errors.required"><span translate>lblRegistrationDateRequired</span>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-6 af-form-group">
                  <label for="template-edit-engineNo" translate>lblEngineNo<strong class="mlt6 required" *ngIf="keepExtraFieldsMandatory"> * </strong>
                  </label>
                  <div class='lbl-info'>
                    <input type="text" id="template-edit-engineNo" name="engineNo"
                      class="form-control" formControlName="engineNo" pattern="^[a-zA-Z0-9_ ]*$"
                      maxlength="100" [required]="keepExtraFieldsMandatory" [ngClass]="{'is-invalid': cpf.engineNo.invalid && cpf.engineNo.touched}">
                    <div *ngIf="cpf.engineNo.invalid && (cpf.engineNo.dirty || cpf.engineNo.touched)"
                      class="help-block text-danger">
                      <div *ngIf="cpf.engineNo.errors.required"><span translate>lblEngineNoRequired</span>
                      </div>
                      <div *ngIf="cpf.engineNo.errors.pattern"><span translate>lblSpecialCharacterNotAllow</span></div>
                    </div>
                  </div>
                </div>

                <div class="col-6 af-form-group">
                  <label for="template-edit-chessisNo" translate>lblVinNumber<strong class="mlt6 required" *ngIf="keepExtraFieldsMandatory"> * </strong>
                  </label>
                  <div class='lbl-info'>
                    <input type="text" id="template-edit-chessisNo" name="chessisNo" formControlName="chessisNo"
                      class="form-control" [required]="keepExtraFieldsMandatory" maxlength="25"
                      [ngClass]="{'is-invalid': cpf.chessisNo.invalid && cpf.chessisNo.touched}">
                    <div *ngIf="cpf.chessisNo.invalid && (cpf.chessisNo.dirty || cpf.chessisNo.touched)"
                      class="help-block text-danger">
                      <div *ngIf="cpf.chessisNo.errors.required"><span translate>lblChessisNoRequired</span>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-6 af-form-group">
                  <label for="template-edit-charges" translate>lblCharges<strong class="mlt6 required"> * </strong>
                  </label>
                  <div class='lbl-info'>
                    <input type="text" id="template-edit-charges" name="charges"  class="form-control"
                    formControlName="charges" pattern="^[\d,.\s]{0,8}$" (blur)="onBlur($event)" (keyup)="checkLength($event)"
                      required [ngClass]="{'is-invalid': cpf.charges.invalid && cpf.charges.touched}">
                    <div *ngIf="cpf.charges.invalid && (cpf.charges.dirty || cpf.charges.touched)" class="help-block text-danger">
                      <div *ngIf="cpf.charges.errors.required"><span translate>lblChargesRequired
                        </span></div>
                      <div *ngIf="cpf.charges.errors.pattern"><span translate>lblChargesUpto4digit</span>
                      </div>
                    </div>
                    <div *ngIf="isChargesLengthError"
                    class="help-block mt-1 text-danger" translate> <em class="ft-alert-circle align-middle"
                      aria-hidden="true"></em>
                    lblChargesUpto4digit
                  </div>
                  <div *ngIf="(cpf.charges.touched && (cpf.charges.errors?.pattern)) || isValidRentalPrice"
                  class="help-block mt-1 text-danger" translate> <em class="ft-alert-circle align-middle"
                    aria-hidden="true"></em>
                  lblValidRentalPrice
                </div>
                  </div>
                </div>

                <div class="col-6 af-form-group">
                  <label>&nbsp;</label>
                  <div class="lbl-info">
                    <div class="custom-control custom-switch">
                      <input class="custom-control-input" id="isActive" #isActive type="checkbox" formControlName="isActive"
                        [checked]="RentalCarInfo.isActive" (change)="onChange(isActive.checked)" />
                      <label class="custom-control-label" for="isActive" translate>lblActive</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="p-3 bg-light pp-footer-top-brdr">
        <div class="row">
          <div class="col-12 d-flex flex-sm-row flex-column justify-content-end mb15">
            <button type="submit" class="btn btn-primary mr-sm-2 btn-lg" aria-label="Center Align" [disabled]="!addRentalCarForm.valid || isChargesLengthError|| isValidRentalPrice" translate>lblAdd</button>
            <a (click)="OnClose()" class="btn btn-secondary btn-lg" translate>lblCancel</a>
          </div>
        </div>
        </div>
      </form>
    </div>
  </div>
</div>